import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang, ui } from '../i18n/LanguageContext';

const STORAGE_KEY = 'cef-cookie-consent';

// Helper other modules can import to check consent before loading tracking tools.
export const hasCookieConsent = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'accepted';
  } catch (e) {
    return false;
  }
};

const CookieConsent = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const timer = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(timer);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch (e) {
      /* ignore */
    }
    window.__cookieConsent = choice;
    window.dispatchEvent(new CustomEvent('cookie-consent', { detail: choice }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 sm:left-auto z-[100] px-4 pb-4 sm:px-6 sm:pb-6 animate-cookie-in"
      role="dialog"
      aria-live="polite"
      aria-label={t(ui.cookies.title)}
      data-testid="cookie-consent-banner"
    >
      <div className="sm:ml-auto w-full sm:max-w-sm bg-[#161514] text-[#f4f1ec] shadow-2xl">
        <div className="p-6 flex flex-col gap-5">
          <div>
            <p className="font-serif text-lg mb-2">{t(ui.cookies.title)}</p>
            <p className="text-sm leading-relaxed text-[#c9c4ba]">
              {t(ui.cookies.message)}{' '}
              <Link
                to="/confidentialite"
                onClick={() => setVisible(false)}
                className="text-champagne underline underline-offset-2 hover:text-white transition-colors"
                data-testid="cookie-consent-learn-more"
              >
                {t(ui.cookies.learnMore)}
              </Link>
            </p>
          </div>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => decide('refused')}
              className="flex-1 px-5 py-2.5 text-sm border border-[#5c584f] text-[#f4f1ec] hover:border-champagne hover:text-champagne transition-colors"
              data-testid="cookie-consent-refuse"
            >
              {t(ui.cookies.refuse)}
            </button>
            <button
              type="button"
              onClick={() => decide('accepted')}
              className="flex-1 px-5 py-2.5 text-sm bg-champagne text-[#161514] hover:bg-white transition-colors"
              data-testid="cookie-consent-accept"
            >
              {t(ui.cookies.accept)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
